import { get, post } from './axios.js'

/**
 * 상품 분류 > 리비전 조회, 상품분류체계 리비전 목록 조회 - /prod/getProdRevIdList
 * @returns
 */
export async function getProdRevIdList() {
  try {
    const result = await post('/prod/getProdRevIdList', {})
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 회계년도별에 해당하는 상품 리비전 가져오기 - /prod/getQuotaProdRevIdList
 * @returns
 */
export async function getQuotaProdRevIdList() {
  try {
    const result = await post('/prod/getQuotaProdRevIdList', {})
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 상품 분류 조회, 상품분류체계 목록 조회 - /prod/prodList
 * @param {object} params
 * @property {sting} params.rev_id
 * @returns
 */
export async function prodList(params = {}) {
  try {
    const result = await post('/prod/prodList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 상품분류체계 등록/수정 - /prod/prodEdit
 * @param {object} params
 * @property {sting} params.class_nm - 상품명
 * @property {sting} params.enable_yn - 활성화 여부
 * @property {sting} params.note - 메모
 * @property {sting} params.fmt_reg_dt - 등록일
 * @property {sting} params.reg_id - 등록자
 * @property {sting} params.fmt_upd_dt - 수정일
 * @property {sting} params.upd_id - 수정자
 * @returns
 */
export async function prodEdit(params = {}) {
  try {
    const result = await post('/prod/prodEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 상품분류체계 삭제 - /prod/prodDelete
 * @param {object} params
 * @property {sting} params.rev_id
 * @property {sting} params.class_id
 * @returns
 */
export async function prodDelete(params = {}) {
  try {
    const result = await post('/prod/prodDelete', params)
    return result.data
  } catch(e) {
    if (e && e.response && e.response.data?.code == "0004") {
      alert(e.response.data.ex_message);
    }
    throw new Error(e)
  }
}

/**
 * 상품분류체계 리비전 업 + 저장 - /prod/prodRevClassInst
 * @param {object} params
 * @property {sting} params.start_dt
 * @property {sting} params.end_dt
 * @property {sting} params.prodClassListVo
 * @returns
 */
export async function prodRevClassInst(params = {}) {
  try {
    const result = await post('/prod/prodRevClassInst', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 상품 분류 > 리비전과 날짜 조회 - /prod/getProdRevList
 * @returns
 */
export async function getProdRevList() {
  try {
    const result = await post('/prod/getProdRevList', {})
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 상품 분류 조회, 상품분류체계 목록 조회 - /prod/prodList
 * @param {object} params
 * @property {sting} params.rev_id
 * @returns
 */
export async function depthProdList(params = {}) {
  try {
    const result = await post('/prod/depthProdList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 상품 분류 조회, 상품분류체계 목록 조회 - /prod/prodList
 * @param {object} params
 * @property {sting} params.rev_id
 * @returns
 */
export async function mappingProd(params = {}) {
  try {
    const result = await post('/prod/mappingProd', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 상품분류 최상위 상품ID 조회 - /prod/PROD_UPPER_ID
 * @param {object} params
 * @property {sting} params.fiscal_year
 * @returns
 */
export async function ProdUpperId(params) {
  try {
    const result = await post('/prod/ProdUpperId', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 상품분류 최상위 상품ID 조회 - /prod/getProdRevIDYearList
 * @param {object} params
 * @property {sting} params.rev_id
 * @returns
 */
export async function getProdRevIDYearList(params) {
  try {
    const result = await post('/prod/getProdRevIDYearList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 상품분류 연도 업데이트 - /prod/getProdRevIDYearList
 * @param {object} params
 * @property {sting} params.rev_id
 * @returns
 */
export async function prodRevYearUpdate(params) {
  try {
    const result = await post('/prod/prodRevYearUpdate', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 상품 분류 조회, 상품분류체계 목록 조회 - /prod/getMappingProdList
 * @param {object} params
 * @property {sting} params.rev_id
 * @returns
 */
export async function getMappingProdList(params = {}) {
  try {
    const result = await post('/prod/getMappingProdList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 상품 분류 조회, 상품분류체계 목록 조회 - /prod/deleteMappingProd
 * @param {object} params
 * @property {sting} params.rev_id
 * @returns
 */
export async function deleteMappingProd(params = {}) {
  try {
    const result = await post('/prod/deleteMappingProd', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 영업기회 상품정보 일괄수정 미리보기 - /prod/previewBulkUpdateProdMapping
 * @param {object} params
 * @property {string} params.fiscal_year - 회계연도 (4자리)
 * @returns
 */
export async function previewBulkUpdateProdMapping(params = {}) {
  try {
    const result = await post('/prod/previewBulkUpdateProdMapping', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 영업기회 상품정보 일괄수정 실행 - /prod/executeBulkUpdateProdMapping
 * @param {object} params
 * @property {string} params.fiscal_year - 회계연도 (4자리)
 * @returns
 */
export async function executeBulkUpdateProdMapping(params = {}) {
  try {
    const result = await post('/prod/executeBulkUpdateProdMapping', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}